
 <div class="right-container">
    <div class="popup-header">
      <button class="close-button" (click)="close()">X</button>
    </div>
    <div class="popup" *ngIf="status === 'Waiting for login...'">
      <qrcode elementType="url" [qrdata]="value || 'No Data'"
      ></qrcode>
    </div>
    <div class="text-container">
      <h1>Comparte tu credencial</h1>
      <p>1. Escanea este código QR con tu app de Incucai</p>
      <p>2. Selecciona la credencial para loguearte</p>
      <p>3. Confirma</p>
    </div>
  </div>






